import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { IconCheck } from 'src/Components/shared/Icon'
import BotHeadColored from 'src/Components/shared/Avatar/BotHeadColored'

import styles from './StatusIcon.module.scss'

const defaultProps = {
  successIcon: IconCheck,
  failureIcon: BotHeadColored,
}

const propTypes = {
  className: PropTypes.string,
  success: PropTypes.bool,
  failure: PropTypes.bool,
  spin: PropTypes.bool,
  successIcon: PropTypes.func,
  failureIcon: PropTypes.func,
}

const StatusIcon = ({
  className,
  success,
  failure,
  spin,
  successIcon: SuccessIcon,
  failureIcon: FailureIcon,
  ...restProps
}) => {
  let MyIcon = null

  if (failure) {
    MyIcon = <FailureIcon type='error' size='l' quizzical />
  } else if (success) {
    MyIcon = <SuccessIcon variant='success' />
  }

  return (
    <span
      className={classnames(
        className,
        styles.root,
        success && styles.success,
        failure && styles.failure,
        spin && styles.spinner
      )}
      {...restProps}
    >
      {MyIcon}
    </span>
  )
}

StatusIcon.defaultProps = defaultProps
StatusIcon.propTypes = propTypes

export default StatusIcon
